import { Box, Stack, styled } from '@mui/material';
import { GAUGE_VISUAL } from '../constants';

export const GaugeContainer = styled(Stack)(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  spacing: 1,
  width: '100%',
  position: 'relative',
  height: '100%',
}));

export const GaugeSvgContainer = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  aspectRatio: GAUGE_VISUAL.ASPECT_RATIO,
  fontSize: 'clamp(10px, 2.5vw, 20px)',
  margin: '0 auto',
  '& svg': {
    width: '100%',
    height: '100%',
  },
}));
